import { MuiTelInputCountry } from "mui-tel-input";

export const countrySelect: MuiTelInputCountry[] = ['AR', 'BO', 'BR', 'CL', 'CO', 'CR', 'CU', 'DO', 'EC', 'GT', 'HN', 'NI', 'PE', 'PY', 'SV', 'UY', 'VE']